var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrypto = function SvgCrypto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 12C2 6.5 6.5 2 12 2s10 4.5 10 10-4.5 10-10 10S2 17.5 2 12m2 0c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8-8 3.6-8 8m11.9-2.2c0 .9-.4 1.6-1.1 2 1.1.4 1.6 1.1 1.7 2.3 0 .9-.3 1.6-1 2.1q-.45.45-1.2.6v1.5h-1.9V17h-1.1v1.3H9.4V17h-.7V7h.7V5.7h1.9V7h1V5.7h1.9v1.7c.188.063.337.165.472.257.08.055.154.106.228.143.7.4 1 1.1 1 2m-3.8-1.1h-1.5V11h1.5c.6 0 1-.1 1.3-.3s.5-.5.5-.9c0-.3-.2-.6-.5-.8s-.8-.3-1.3-.3m.4 6.5c.6 0 1.1-.1 1.4-.3s.5-.5.5-1c0-.4-.2-.7-.5-.9s-.8-.3-1.4-.3h-1.9v2.5z",
    clipRule: "evenodd"
  })));
};
export default SvgCrypto;